import { CountryData, CountryState } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';

export default {
    getCountries(state): Record<string, any> {
        return state.countries;
    },
    getSelectedCountryData: (state) => (country: string): undefined|CountryData => {
        return state.countries.optionGroups
            .flat()
            .find(option => option.name === country);
    },
    getCombinedOptionGroups(state): Record<string, any> {
        const flatten = state.countries.optionGroups.flat();

        return flatten.filter((item) => item.dialCode > 0);
    }
} as GetterTree<CountryState, IStore>
